import { render, staticRenderFns } from "./Meal.vue?vue&type=template&id=4dac891e&scoped=true&"
import script from "./Meal.vue?vue&type=script&lang=js&"
export * from "./Meal.vue?vue&type=script&lang=js&"
import style0 from "./Meal.vue?vue&type=style&index=0&id=4dac891e&scoped=true&lang=css&"
import style1 from "./Meal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dac891e",
  null
  
)

export default component.exports